import { render, staticRenderFns } from "./uploadPaymentProof.vue?vue&type=template&id=16c28131&scoped=true&"
import script from "./uploadPaymentProof.vue?vue&type=script&lang=js&"
export * from "./uploadPaymentProof.vue?vue&type=script&lang=js&"
import style0 from "./uploadPaymentProof.vue?vue&type=style&index=0&id=16c28131&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c28131",
  null
  
)

export default component.exports